import React from 'react';
import { css } from '@emotion/core';
import { SyncLoader } from 'react-spinners';

const override = css`
    display: block;
    text-align: center;
    position: absolute;
    top: 50%;
    left: 50%;
    margin: -50px 0px 0px -50px;
`;

const Spinner = () => {
    return (
        <div id={'spinner'}>
            <SyncLoader
                css={override}
                sizeUnit={'px'}
                size={15}
                margin={'4px'}
                color={'#009AD9'}
                loading={true}
            />
        </div>
    );
};

export default Spinner;
